import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import styled from "styled-components"

const PROJECTS = [
  {
    href: "https://itsyst.github.io/python-strudy/",
    name: "Python Study Notes",
    image: "/projects/python-strudy.jpg",
  },
  {
    href: "https://react-video-x.vercel.app/",
    name: "React Video",
    image: "/projects/react-video.jpg",
  },
  {
    href: "https://video-game-prend.netlify.app/",
    name: "Game Hub",
    image: "/projects/game-hub.jpg",
  },
]

export const SideCard = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          author
        }
      }
      portrait: file(relativePath: { eq: "me.png" }) {
        childImageSharp {
          gatsbyImageData(width: 480, placeholder: BLURRED)
        }
      }
    }
  `)
  const image = getImage(data.portrait)

  return (
    <Aside>
      <Bio>
        {image ? <GatsbyImage image={image} alt={data.site.siteMetadata.author} /> : null}
        <h2>{data.site.siteMetadata.author}</h2>
        <p>
          Vill du stötta arbetet? En kaffe på{" "}
          <a href="https://ko-fi.com/itsyst" target="_blank" rel="noopener noreferrer">
            Ko-fi
          </a>{" "}
          eller ett medlemskap på{" "}
          <a href="https://www.patreon.com/c/itsyst" target="_blank" rel="noopener noreferrer">
            Patreon
          </a>
          .
        </p>
        <More to="/about">Mer om mig</More>
      </Bio>
      <Ads>
        {PROJECTS.map(project => (
          <a
            key={project.href}
            href={project.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={project.name}
          >
            <img src={project.image} alt="" />
          </a>
        ))}
      </Ads>
    </Aside>
  )
}

const Aside = styled.aside`
  display: block;
  align-self: start;
  padding-top: 1.75rem;
`

const Bio = styled.div`
  display: none;

  @media ${props => props.theme.breakpoints.desktop} {
    display: block;

    .gatsby-image-wrapper {
      display: block;
      aspect-ratio: 4 / 5;
      border-radius: 0;
    }

    h2 {
      margin: 1rem 0 0;
      font-size: 1.25rem;
    }

    p {
      margin: 0.6rem 0 0;
      color: var(--muted);
      font-size: 0.9rem;
      line-height: 1.55;
    }
  }
`

const More = styled(Link)`
  display: inline-block;
  margin-top: 0.75rem;
  font-size: 0.875rem;
  color: var(--accent);
`

const Ads = styled.div`
  display: grid;
  gap: 0.75rem;

  @media ${props => props.theme.breakpoints.desktop} {
    margin-top: 2.25rem;
    padding-top: 1.15rem;
    border-top: 1px solid var(--border);
  }

  a {
    display: block;
    overflow: hidden;
    background: color-mix(in srgb, var(--fg) 5%, transparent);
  }

  img {
    display: block;
    width: 100%;
    aspect-ratio: 3 / 2;
    object-fit: cover;
    border-radius: 0;
    transition: transform 250ms cubic-bezier(0.22, 1, 0.36, 1);
  }

  a:hover img {
    transform: scale(1.03);
  }
`
